import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  accordionBackground: {
    background: '#ececec',
  },
  inputField: {
    marginTop: 15,
  },
  buttonGroup: {
    marginBottom: 15,
  },
  button: {
    marginRight: 15,
  },
  wrapper: {
    width: '100%',
    padding: 15,
  },
  swalDialog: {
    zIndex: 1350,
  },
  mainBlockHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  spaceIconText: {
    marginLeft: 3,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  sortableHelper: {
    zIndex: 1400,
  },
  autosaveLoading: {
    textAlign: 'left',
  },
  formControl: {
    width: 200,
  },
}));
